var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16449_1441)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16449_1441",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16449_1441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37253 0 0 5.37253 0 12C0 18.6274 5.37253 24 12 24C18.6275 24 24 18.6274 24 12C23.9999 5.37253 18.6274 0 12 0ZM8.79836 17.8014H6.16364V9.2894H8.79836V17.8014ZM7.46845 8.17468C6.60798 8.17468 5.91041 7.47144 5.91041 6.60408C5.91041 5.73661 6.60807 5.03341 7.46845 5.03341C8.32882 5.03341 9.02638 5.73661 9.02638 6.60408C9.02643 7.47148 8.32886 8.17468 7.46845 8.17468ZM18.672 17.8014H16.05V13.3333C16.05 12.1079 15.5845 11.4238 14.6155 11.4238C13.5609 11.4238 13.0099 12.1362 13.0099 13.3333V17.8014H10.4829V9.2894H13.0099V10.4358C13.0099 10.4358 13.77 9.02976 15.5749 9.02976C17.3799 9.02976 18.672 10.1318 18.672 12.4117V17.8014Z",
    fill: "#FAFAFA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16449_1441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.55600fd2a40e2ba3dfd7db64adb91308.svg";
export { ForwardRef as ReactComponent };